export const NEW_YORK_CITY_COORDINATES = {
  latitude: 40.7127753,
  longitude: -74.0059728,
};
